import Rest from '@/services/Rest';

/**
 * @typedef {ClubService}
 */
export default class ClubService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/club'
}